// extracted by mini-css-extract-plugin
export default {"heading":"HelpCenter_heading__umEoM","text":"HelpCenter_text__zcWcz","btn":"HelpCenter_btn__+OBGM"};